
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_388_433)","stroke":"#00CFE8","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 12.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM10 12.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z"}}),_c('path',{attrs:{"d":"M12 11H4.385V2H3"}}),_c('path',{attrs:{"d":"M4 3l9 .625L12.357 8H4"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_388_433"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    